var render = function () {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c("div", { class: [_vm.$style.example_content_item] }, [
    _c(
      "div",
      {
        class: [_vm.$style.example_content_item_title, _vm.$style.first_title],
      },
      [_vm._v("\n    " + _vm._s(_vm.title) + "\n  ")]
    ),
    _vm._v(" "),
    _c("div", { class: _vm.$style.example_content_2_items }, [
      _c(
        "div",
        {
          class: _vm.$style.example_block,
          on: {
            click: function () {
              return _vm.onCreateReport(
                "milestone",
                _vm.progressTitleLocales.milestone
              )
            },
          },
        },
        [
          _c(
            "div",
            { class: _vm.$style.example_block_title },
            [
              _c("div", { class: _vm.$style.text }, [
                _vm._v(
                  "\n          " +
                    _vm._s(
                      _vm.locale("" + _vm.progressTitleLocales.milestone)
                    ) +
                    "\n        "
                ),
              ]),
              _vm._v(" "),
              _c("vgp-button", {
                class: _vm.$style.example_create_but,
                attrs: {
                  type: "text",
                  small: true,
                  label: _vm.locale("common_create"),
                },
              }),
            ],
            1
          ),
          _vm._v(" "),
          _c("div", { class: _vm.$style.example_block_desc }, [
            _vm._v(
              "\n        " +
                _vm._s(_vm.locale("exmp_chart_milestone_desc")) +
                "\n      "
            ),
          ]),
          _vm._v(" "),
          _c("div", { class: _vm.$style.example_block_chart }, [
            _c("img", {
              class: _vm.$style.img,
              attrs: {
                src: "https://cdn.ganttpro.com/app/imgs/reports/reportMilestone.png",
              },
            }),
          ]),
        ]
      ),
      _vm._v(" "),
      _c(
        "div",
        {
          class: _vm.$style.example_block,
          on: {
            click: function () {
              return _vm.onCreateReport(
                "statuses",
                _vm.progressTitleLocales.status
              )
            },
          },
        },
        [
          _c(
            "div",
            { class: _vm.$style.example_block_title },
            [
              _c("div", { class: _vm.$style.text }, [
                _vm._v(
                  "\n          " +
                    _vm._s(_vm.locale("" + _vm.progressTitleLocales.status)) +
                    "\n        "
                ),
              ]),
              _vm._v(" "),
              _c("vgp-button", {
                class: _vm.$style.example_create_but,
                attrs: {
                  type: "text",
                  small: true,
                  label: _vm.locale("common_create"),
                },
              }),
            ],
            1
          ),
          _vm._v(" "),
          _c("div", { class: _vm.$style.example_block_desc }, [
            _vm._v(
              "\n        " +
                _vm._s(_vm.locale("exmp_chart_project_by_status_desc")) +
                "\n      "
            ),
          ]),
          _vm._v(" "),
          _c("div", { class: _vm.$style.example_block_chart }, [
            _c("img", {
              class: _vm.$style.img,
              attrs: {
                src: "https://cdn.ganttpro.com/app/imgs/reports/reportStatus.png",
              },
            }),
          ]),
        ]
      ),
    ]),
    _vm._v(" "),
    _c("div", { class: _vm.$style.example_content_2_items }, [
      _c(
        "div",
        {
          class: [_vm.$style.example_block, _vm.$style.full_size],
          on: {
            click: function () {
              return _vm.onCreateReport(
                "portfolio",
                _vm.progressTitleLocales.projectsList
              )
            },
          },
        },
        [
          _c(
            "div",
            { class: _vm.$style.example_block_title },
            [
              _c("div", { class: _vm.$style.text }, [
                _vm._v(
                  "\n          " +
                    _vm._s(
                      _vm.locale("" + _vm.progressTitleLocales.projectsList)
                    ) +
                    "\n        "
                ),
              ]),
              _vm._v(" "),
              _c("vgp-button", {
                class: _vm.$style.example_create_but,
                attrs: {
                  type: "text",
                  small: true,
                  label: _vm.locale("common_create"),
                },
              }),
            ],
            1
          ),
          _vm._v(" "),
          _c("div", { class: _vm.$style.example_block_desc }, [
            _vm._v(
              "\n        " +
                _vm._s(_vm.locale("exmp_chart_project_list_desc")) +
                "\n      "
            ),
          ]),
          _vm._v(" "),
          _c(
            "div",
            {
              class: _vm.$style.example_block_chart,
              style: { paddingBottom: "38px" },
            },
            [
              _c("img", {
                class: _vm.$style.img,
                attrs: {
                  src: "https://cdn.ganttpro.com/app/imgs/reports/reportProjectsList.png",
                },
              }),
            ]
          ),
        ]
      ),
    ]),
    _vm._v(" "),
    _c("div", { class: _vm.$style.example_content_2_items }, [
      _c(
        "div",
        {
          class: [_vm.$style.example_block],
          on: {
            click: function () {
              return _vm.onCreateReport(
                "schedule",
                _vm.progressTitleLocales.schedule
              )
            },
          },
        },
        [
          _c(
            "div",
            { class: _vm.$style.example_block_title },
            [
              _c("div", { class: _vm.$style.text }, [
                _vm._v(
                  "\n          " +
                    _vm._s(_vm.locale("" + _vm.progressTitleLocales.schedule)) +
                    "\n        "
                ),
              ]),
              _vm._v(" "),
              _c("vgp-button", {
                class: _vm.$style.example_create_but,
                attrs: {
                  type: "text",
                  small: true,
                  label: _vm.locale("common_create"),
                },
              }),
            ],
            1
          ),
          _vm._v(" "),
          _c("div", { class: _vm.$style.example_block_desc }, [
            _vm._v(
              "\n        " +
                _vm._s(_vm.locale("exmp_chart_project_schedule_desc")) +
                "\n      "
            ),
          ]),
          _vm._v(" "),
          _c("div", { class: _vm.$style.example_block_chart }, [
            _c("img", {
              class: _vm.$style.img,
              attrs: {
                src: "https://cdn.ganttpro.com/app/imgs/reports/reportSchedule.png",
              },
            }),
          ]),
        ]
      ),
      _vm._v(" "),
      _c(
        "div",
        {
          class: [_vm.$style.example_block],
          on: {
            click: function () {
              return _vm.onCreateReport(
                "month",
                _vm.progressTitleLocales.monthProgress
              )
            },
          },
        },
        [
          _c(
            "div",
            { class: _vm.$style.example_block_title },
            [
              _c("div", { class: _vm.$style.text }, [
                _vm._v(
                  "\n          " +
                    _vm._s(
                      _vm.locale("" + _vm.progressTitleLocales.monthProgress)
                    ) +
                    "\n        "
                ),
              ]),
              _vm._v(" "),
              _c("vgp-button", {
                class: _vm.$style.example_create_but,
                attrs: {
                  type: "text",
                  small: true,
                  label: _vm.locale("common_create"),
                },
              }),
            ],
            1
          ),
          _vm._v(" "),
          _c("div", { class: _vm.$style.example_block_desc }, [
            _vm._v(
              "\n        " +
                _vm._s(_vm.locale("exmp_chart_progress_by_month_desc")) +
                "\n      "
            ),
          ]),
          _vm._v(" "),
          _c("div", { class: _vm.$style.example_block_chart }, [
            _c("img", {
              class: _vm.$style.img,
              attrs: {
                src: "https://cdn.ganttpro.com/app/imgs/reports/reportProgressMonth.png",
              },
            }),
          ]),
        ]
      ),
    ]),
  ])
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }